import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine1Body1CenterSecondary,
  TextBoxMaxLine1Headline1Center,
  TextBoxMaxLine2Body1Center,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockDescriptionForBundleGridCenterProps extends Omit<
  ITextBlockProps,
  'children'
> {
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  descriptionPreWrap?: boolean
  rentedText?: string
}

export const TextBlockDescriptionForBundleGridCenter = ({
  title = '',
  description = '',
  rowGap = TextBlockRowGap.INDENT_0,
  descriptionPreWrap,
  rentedText,
  ...rest
}: ITextBlockDescriptionForBundleGridCenterProps): JSX.Element => (
  <TextBlock rowGap={TextBlockRowGap.INDENT_20} {...rest}>
    {rentedText && <TextBoxMaxLine1Body1CenterSecondary title={rentedText} />}

    <TextBlock rowGap={rowGap} {...rest}>
      <TextBoxMaxLine1Headline1Center title={title} />
      <TextBoxMaxLine2Body1Center preWrap={descriptionPreWrap}>
        {description}
      </TextBoxMaxLine2Body1Center>
    </TextBlock>
  </TextBlock>
)
